var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{},[_c('avatar',{attrs:{"original":_vm.original,"thumbnail":_vm.avatar,"text":_vm.user.name,"id":_vm.user.id}}),_vm._v(" "+_vm._s(_vm.user.name)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }